import commonRoutes, {
  bareRoutes,
  projectBased,
} from '../../shared/constants/commonRoutes'

const desktopRoutes = {
  ...commonRoutes,

  PROJECT_SETUP: projectBased(bareRoutes.PROJECT_SETUP),
  PROJECT_DETAILS: projectBased('/projectSetup?page=1'),
  USER_PROFILE: projectBased('/projectSetup?page=edit-profile'),
  MAP_SETUP: projectBased('/projectSetup?page=map-setup'),
  MATERIALS: projectBased('/materials'),
  FILES: projectBased('/files'),
  ANALYTICS: projectBased('/analytics'),
  EQUIPMENT: projectBased(bareRoutes.EQUIPMENT),
  STRUXTAGS: projectBased(bareRoutes.STRUXTAGS),
  LOCATIONS: projectBased(bareRoutes.LOCATIONS),
  MATERIAL_RESOURCES: projectBased(bareRoutes.MATERIAL_RESOURCES),
  NOTIFICATIONS_DETAILS: projectBased('/notifications/:notificationId'),
}

export default desktopRoutes
